/**
 * OCR vs CPCFA import vs plain digital form — used for display and future field routing.
 */

export const hasStructuredPayload = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed !== '' && trimmed !== '{}' && trimmed !== '[]' && trimmed !== 'null';
  }
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value as Record<string, unknown>).length > 0;
  return true;
};

/**
 * True OCR means native OCR intake, not CPCFA import blob.
 */
export const isTrueOcrApplication = ({
  applicationConfig,
  rawOcr,
  cpcfaImportBlob,
}: {
  applicationConfig: unknown;
  rawOcr: unknown;
  cpcfaImportBlob: unknown;
}): boolean => {
  const cfg = applicationConfig as { isUsingOcr?: boolean } | null | undefined;
  if (cfg?.isUsingOcr === true) return true;
  return hasStructuredPayload(rawOcr) && !hasStructuredPayload(cpcfaImportBlob);
};

export type ApplicationIntakeKind = 'ocr' | 'cpcfaImport' | 'digitalForm';

export function resolveApplicationIntakeKind(params: {
  applicationConfig: unknown;
  rawOcr: unknown;
  cpcfaImportBlob: unknown;
}): ApplicationIntakeKind {
  if (
    isTrueOcrApplication({
      applicationConfig: params.applicationConfig,
      rawOcr: params.rawOcr,
      cpcfaImportBlob: params.cpcfaImportBlob,
    })
  ) {
    return 'ocr';
  }
  if (hasStructuredPayload(params.cpcfaImportBlob)) {
    return 'cpcfaImport';
  }
  return 'digitalForm';
}

export function applicationIntakeKindLabel(kind: ApplicationIntakeKind): string {
  switch (kind) {
    case 'ocr':
      return 'OCR intake';
    case 'cpcfaImport':
      return 'CPCFA import';
    case 'digitalForm':
      return 'Digital form';
    default:
      return 'Unknown';
  }
}
